import { InputIban } from '@insify/components';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { CheckoutFormType } from '../../..';

export function Sepa({ className }: { className?: string }): JSX.Element {
  const { t } = useTranslation(['funnel']);
  const { register, formState } = useFormContext<CheckoutFormType>();

  return (
    <InputIban
      id='iban'
      className={className}
      trackingId='iban'
      {...register('iban')}
      label={t('funnel:checkout_iban_label')}
      error={formState.errors.iban?.message}
      placeholder={t('funnel:checkout_iban_label')}
    />
  );
}
